import { AdvertisingContent } from "../interfaces/contents"

// Русские формы: [1, 2-4, 5+], с учётом 11–14.
const plural = (count: number, forms: [string, string, string]): string => {
  const mod100 = count % 100
  const mod10 = count % 10
  if (mod100 >= 11 && mod100 <= 14) {
    return forms[2]
  }
  if (mod10 === 1) {
    return forms[0]
  }
  if (mod10 >= 2 && mod10 <= 4) {
    return forms[1]
  }
  return forms[2]
}

export const formatBytes = (bytes: number): string => {
  if (bytes < 1024) {
    return `${bytes} Б`
  }
  const units: Array<[string, number]> = [
    ["КБ", 1024],
    ["МБ", 1024 ** 2],
    ["ГБ", 1024 ** 3],
  ]
  let value = bytes
  let unit = units[0][0]
  for (const [label, divisor] of units) {
    value = bytes / divisor
    unit = label
    if (value < 1024) {
      break
    }
  }
  const rounded = value.toFixed(1)
  return `${rounded.endsWith(".0") ? rounded.slice(0, -2) : rounded} ${unit}`
}

// «N ордеров · M кампаний» / «Нет привязок» (FR-3).
export const bindingsSummaryText = (
  contentItem: AdvertisingContent,
): string => {
  const orders = contentItem.order_ids.length
  const campaigns = contentItem.campaign_ids.length
  if (orders === 0 && campaigns === 0) {
    return "Нет привязок"
  }
  const parts: string[] = []
  if (orders > 0) {
    parts.push(`${orders} ${plural(orders, ["ордер", "ордера", "ордеров"])}`)
  }
  if (campaigns > 0) {
    parts.push(
      `${campaigns} ${plural(campaigns, ["кампания", "кампании", "кампаний"])}`,
    )
  }
  return parts.join(" · ")
}

// «3 файла: баннер.gif (41.8 КБ), ролик.mp4 (1.5 МБ)» / «Без файлов» (FR-3).
export const filesSummaryText = (contentItem: AdvertisingContent): string => {
  if (contentItem.assets.length === 0) {
    return "Без файлов"
  }
  const list = contentItem.assets
    .map((asset) => `${asset.filename} (${formatBytes(asset.size_bytes)})`)
    .join(", ")
  return `${contentItem.assets.length} ${plural(contentItem.assets.length, ["файл", "файла", "файлов"])}: ${list}`
}

// Индикатор «Кнопки: N» (FR-3); без разметки — 0.
export const buttonsCount = (contentItem: AdvertisingContent): number =>
  contentItem.reply_markup?.inline_keyboard.reduce(
    (sum, row) => sum + row.length,
    0,
  ) ?? 0
